export const ArNXMTokenEvents = {
  GetBalance: 'ArNXMToken.GetBalance',
  BalanceReturned: 'ArNXMToken.BalanceReturned',

  Approve: 'ArNXMToken.Approve',
  ApproveCompleted: 'ArNXMToken.ApproveCompleted',

  GetAllowance: 'ArNXMToken.GetAllowance',
  AllowanceReturned: 'ArNXMToken.AllowanceReturned',
}
